/**
 * Paket özelliğine bağlı sayfalar.
 *
 * Sayfanın üstündeki deneme sayacı (`FeatureTrialBanner`) hangi rotanın hangi
 * özelliğe ait olduğunu buradan çözer. Liste sidebar'daki `feature` alanıyla
 * AYNI eşleşmeyi taşır; yeni bir özellik menüye eklenirken buraya da eklenmelidir,
 * aksi hâlde o sayfada deneme sayacı çıkmaz (erişim yine de doğru çalışır).
 */
export const FEATURE_ROUTES = [
  { path: "/admin/pos-raporu", feature: "POS_ANALYTICS" },
  { path: "/payment-links", feature: "PAYMENT_LINK" },
  { path: "/invoice-tracking", feature: "DEBT_REMINDER" },
  { path: "/schedule-reports", feature: "SCHEDULED_REPORTS" },
  { path: "/support", feature: "SUPPORT_TICKETS" },
]

/**
 * Rotanın bağlı olduğu özellik kodu — yoksa null.
 * Alt sayfalar da kapsanır (ör. /payment-links/olustur), bu yüzden önek eşleşmesi
 * kullanılır; en uzun eşleşme kazanır ki iç içe rotalarda yanlış özellik seçilmesin.
 */
export const featureForPath = (pathname) => {
  if (!pathname) return null
  const match = FEATURE_ROUTES
    .filter(r => pathname === r.path || pathname.startsWith(`${r.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0]
  return match ? match.feature : null
}
